import { render, staticRenderFns } from "./NavGroup.vue?vue&type=template&id=5cff8fb2&"
import script from "./NavGroup.vue?vue&type=script&lang=js&"
export * from "./NavGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports